export default __webpack_public_path__ + "static/media/carL.fe2c7827.png";